import { Injectable } from '@angular/core';
import { Country } from '@app/shared/models/country.model';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CountryAdapter } from '../services/country/country.adapter';
import { CountryService } from '../services/country/country.service';

@Injectable()
export class CountriesStoreService {
    private countries: Country[] = [];

    constructor(private countryService: CountryService, private countryAdapter: CountryAdapter) {}

    setCountries(): Observable<Country[]> {
        if (this.countries.length) {
            return of(this.countries);
        }

        return this.countryService.getCountries().pipe(tap((result) => (this.countries = result)));
    }

    getCountries(): Country[] {
        return this.countries;
    }

    getCountry(code: string): Country {
        return (
            this.countries.find((country: Country) => country.code === code) ??
            this.countryAdapter.adapt({})
        );
    }
}
